export default {"src":"/_next/static/media/leaderboard_empty.39a26dd4.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};